import fetcher from '../modules/ajio-fetch';
import { setErrorObject, showError } from './shared/HTTPError';
import endPoints from '../modules/ajio-util/endpoints';
import endPointProperties from '../modules/ajio-util/properties';
import { showModal, hideModal } from './modal';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  errorParser
} from '../modules/ajio-fetch/utils';

export function setMetaDataDetails(res, storeName) {
  return dispatch => {
    const { storeMetalistdto = [] } = res;
    const name = storeName || '';

    let metaData = {
      stores: {}
    };
    storeMetalistdto.map(key => {
      metaData.stores[key.storeId.toLowerCase()] = key;
    });
    metaData = { ...metaData, name };

    dispatch({
      type: 'UPDATE_WEBPAGE_METADATA',
      metaData
    });
    return metaData.stores;
  };
}

export function setCurrentStore(currentTheme = {}) {
  return {
    type: 'SET_CURRENT_STORE_THEME',
    current: currentTheme
  };
}

export function setSIS() {
  return {
    type: 'SWITCH_SIS_ON'
  };
}

export function toggleStoreNav(showStoreNav = false) {
  if (!showStoreNav && document) {
    document.body.classList.add('noScroll');
  } else if (showStoreNav && document) {
    document.body.classList.remove('noScroll');
  }

  return {
    type: 'TOGGLE_STORE_NAV'
  };
}

export function updateNavgationInfo(navDataObj) {
  return {
    type: 'SET_NAVIGATION_INFORMATION',
    navDataObj
  };
}

export function setSubStoreNavigation(navigation = {}) {
  return {
    type: 'SET_SUB_STORE_NAVIGATION',
    navigation
  };
}

export function setMetaData(req, storeval = '') {
  return dispatch => {
    const apiEndPoint = `${endPoints.get('getStoreList')}?format=json`;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'GET',
        headers: { 'content-type': 'application/json' }
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const { sisStoreList = [] } = response;
        const { hostname = '' } = req;
        const themesMap = dispatch(setMetaDataDetails(sisStoreList[0], storeval));
        const currentStoreMetaData = themesMap[storeval] || {};
        dispatch(setCurrentStore(currentStoreMetaData));
        if (Object.keys(currentStoreMetaData).length) {
          dispatch(setSIS());
        }
      
      })
      .catch(error => {
        console.log(error);
        const statusCode = getErrorStatusCode(error);
        dispatch(showError('setmetadata', statusCode));
        // TODO-GA
        // let statusCode = getErrorStatusCode(error);
        // errorParser(error,statusCode).then((errorObj = {}) => {
        //     tokenReCreateParser(statusCode,errorObj).then(() =>{
        //         checkDeliveryable(pincode, callback)(dispatch);
        //     })
        //     .catch(() => {
        //         dispatch(setErrorObject(errorObj));
        //         dispatch(hideLoader("cart-loader"));
        //     });
        // });
      });
  };
}


export function setPrimaryHeight(height = 90) {
  return {
    type: 'UPDATE_PRIMARY_HEIGHT',
    height
  };
}

export function updateSubHeaderHeight(height, subLogoHeight) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_SUBHEADER_HEIGHT',
      height,
      subLogoHeight
    });
  };
}

export function updateSISnavigation(navigation) {
  return dispatch => {
    dispatch({
      type: 'SET_SUB_STORE_NAVIGATION',
      navigation
    });
  };
}

export function updateSubHeaderLogoHeight(subLogoHeight) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_SUBHEADER_LOGO_HEIGHT',
      subLogoHeight
    });
  };
}

export function resetMetaData() {
  return dispatch => {
    dispatch({ type: 'RESET_WEBPAGE_METADATA' });
  };
}




export function setLayoutModalContent(content = '', optional = {}, name = 'layout-modal') {
  return dispatch => {
    dispatch({
      type: 'SHOW_LAYOUT_MODAL',
      payload: {
        content,
        showModal: true,
        optional: { ...optional }
      }
    });

    dispatch(showModal(name));
  };
}

export function removeLayoutModalContent(name = 'layout-modal') {
  return dispatch => {
    dispatch({
      type: 'HIDE_LAYOUT_MODAL',
      payload: {
        content: '',
        showModal: false,
        optional: {}
      }
    });
    dispatch(hideModal(name));
  };
}

export function showLayoutToast(name = 'layout-toast', content = '') {
  return dispatch => {
    dispatch({
      type: 'SHOW_LAYOUT_TOAST',
      payload: {
        toastContent: content,
        showToast: true
      }
    });
  };
}

export function hideLayoutToast(name = 'layout-toast') {
  return dispatch => {
    dispatch({
      type: 'HIDE_LAYOUT_TOAST',
      payload: {
        toastContent: '',
        showToast: false
      }
    });
  };
}
